export function tmd(string) {
  let propName = ""

  switch(string) {
    case "all":
      propName = "Base Completa"
      break
    case "user_stored_data.createdAt":
      propName = "Data de coleta do usuário"
      break
    case ">":
      propName = "maior que"
      break
    case "==":
      propName = "igual a"
      break
    case "<":
      propName = "menor que"
      break
    case "!=":
      propName = "diferente de"
      break
    case "contain":
      propName = "contém"
      break
    case "notcontain":
      propName = "não contém"
      break
    case "pageview":
      propName = "Visualização de Página"
      break 
    case "CELL_NOTIFICATION":
      propName = "Notificações push"
      break
    default:
      propName = string
      break
  }

  return propName
}